const colors = {
  white: "#FFFFFF",
  cobalt: "#2662E2",
  caribbean: "#22E9A5",
  cerulean: "#8181A5",
  gray1: "#F6F6F6",
  gray2: "#E9E9F2",
  gray3: "#1C1D21",
  gray4: "#A5A5A5",
  gray5: "#F5F5FA",
  gray6: "#7C8495",
  gray7: "#9d9d9d",
  gray8: "#4b4b4b",
  gray9: "#ECECF2",
  gray10: "#f2f2f6",
  blue1: "#0047AB",
  blue2: "#5E81F4",
  blue3: "#34495E",
  blue4: "#094AA8",
  blue5: "#cedbee",
  lightBlue1: "#0C71FF",
  lightBlue2: "#DEEBFF",
  red: "#F54B5E",
  red2: "#FFC2C5",
  red3: "#FF3D47",
  sky: "#00A7F2",
  black: "#000000",
  green: "#77B255",
}

export default colors
